import React from 'react';
import {
  Container,
  Typography,
  Box,
  Paper,
  AppBar,
  Toolbar,
  IconButton
} from '@mui/material';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from '../../hooks/useTranslation';

const TermsOfService = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <Box>
      <AppBar position="static" sx={{ backgroundColor: 'white', color: 'black', boxShadow: 1 }}>
        <Toolbar>
          <IconButton onClick={() => navigate('/')} sx={{ mr: 2 }}>
            <ArrowBackIcon />
          </IconButton>
          <Typography variant="h6" component="div" sx={{ fontWeight: 'bold' }}>
            {t('legal.termsOfServiceTitle')}
          </Typography>
        </Toolbar>
      </AppBar>

      <Container maxWidth="md" sx={{ py: 4 }}>
        <Paper elevation={0} sx={{ p: 4, border: '1px solid #e0e0e0' }}>
          <Typography variant="h4" gutterBottom sx={{ fontWeight: 'bold', mb: 4 }}>
            {t('legal.termsOfService')}
          </Typography>

          <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
            {t('legal.lastUpdated')}
          </Typography>

          <Box sx={{ '& > *': { mb: 3 } }}>
            <Box>
              <Typography variant="h5" gutterBottom sx={{ fontWeight: 600 }}>
                {t('legal.acceptanceOfTerms')}
              </Typography>
              <Typography variant="body1" paragraph>
                {t('legal.acceptanceDescription')}
              </Typography>
            </Box>

            <Box>
              <Typography variant="h5" gutterBottom sx={{ fontWeight: 600 }}>
                {t('legal.serviceDescription')}
              </Typography>
              <Typography variant="body1" paragraph>
                {t('legal.serviceDescriptionText')}
              </Typography>
              <Typography variant="body1" paragraph>
                {t('legal.companyAddress')}
              </Typography>
            </Box>

            <Box>
              <Typography variant="h5" gutterBottom sx={{ fontWeight: 600 }}>
                {t('legal.userAccount')}
              </Typography>
              <Typography variant="body1" paragraph>
                {t('legal.userAccountDescription')}
              </Typography>
              <Typography component="ul" variant="body1" sx={{ pl: 3 }}>
                <li>{t('legal.loginConfidentiality')}</li>
                <li>{t('legal.informationAccuracy')}</li>
                <li>{t('legal.accountActivities')}</li>
              </Typography>
            </Box>

            <Box>
              <Typography variant="h5" gutterBottom sx={{ fontWeight: 600 }}>
                {t('legal.acceptableUse')}
              </Typography>
              <Typography variant="body1" paragraph>
                {t('legal.acceptableUseDescription')}
              </Typography>
              <Typography component="ul" variant="body1" sx={{ pl: 3 }}>
                <li>{t('legal.noIllegalUse')}</li>
                <li>{t('legal.noOffensiveContent')}</li>
                <li>{t('legal.noSecurityCompromise')}</li>
                <li>{t('legal.noSpamHarassment')}</li>
              </Typography>
            </Box>

            <Box>
              <Typography variant="h5" gutterBottom sx={{ fontWeight: 600 }}>
                {t('legal.subscriptionsPayments')}
              </Typography>
              <Typography variant="body1" paragraph>
                {t('legal.subscriptionsPaymentsDescription')}
              </Typography>
            </Box>

            <Box>
              <Typography variant="h5" gutterBottom sx={{ fontWeight: 600 }}>
                {t('legal.intellectualProperty')}
              </Typography>
              <Typography variant="body1" paragraph>
                {t('legal.intellectualPropertyDescription')}
              </Typography>
            </Box>

            <Box>
              <Typography variant="h5" gutterBottom sx={{ fontWeight: 600 }}>
                {t('legal.liabilityLimitation')}
              </Typography>
              <Typography variant="body1" paragraph>
                {t('legal.liabilityLimitationDescription')}
              </Typography>
            </Box>

            <Box>
              <Typography variant="h5" gutterBottom sx={{ fontWeight: 600 }}>
                {t('legal.termination')}
              </Typography>
              <Typography variant="body1" paragraph>
                {t('legal.terminationDescription')}
              </Typography>
            </Box>

            <Box>
              <Typography variant="h5" gutterBottom sx={{ fontWeight: 600 }}>
                {t('legal.applicableLaw')}
              </Typography>
              <Typography variant="body1" paragraph>
                {t('legal.applicableLawDescription')}
              </Typography>
            </Box>

            <Box>
              <Typography variant="h5" gutterBottom sx={{ fontWeight: 600 }}>
                {t('legal.contact')}
              </Typography>
              <Typography variant="body1" paragraph>
                {t('legal.contactDescription')}
              </Typography>
            </Box>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};

export default TermsOfService;